export const SUPPORT_ACTION_TYPES = Object.freeze({
  CONTACT_SUPPORT: 'contact_support',
  OPEN_RESPONSIBLE_CONTACTS: 'open_responsible_contacts',
  START_NEW_TOPIC: 'start_new_topic',
  CALL_SUPPORT: 'call_support',
  TEXT_SUPPORT: 'text_support'
})

export const SUPPORT_ACTION_REASONS = Object.freeze({
  UNRESOLVED_TECHNICAL_ISSUE: 'unresolved_technical_issue',
  USER_REQUESTED_HUMAN_HELP: 'user_requested_human_help',
  TOPIC_CHANGED: 'topic_changed',
  MESSAGE_LIMIT_REACHED: 'message_limit_reached',
  NEEDS_MANAGER: 'needs_manager',
  NEEDS_SCHEDULER: 'needs_scheduler',
  NEEDS_PAYROLL: 'needs_payroll',
  NEEDS_HR: 'needs_hr',
  NEEDS_CREDENTIALING: 'needs_credentialing',
  NEEDS_ADMINISTRATOR: 'needs_administrator'
})

export const SUPPORT_ACTION_LABELS = Object.freeze({
  ASK_NEW_QUESTION: 'Ask a New Question',
  START_NEW_QUESTION: 'Start a New Question',
  OPEN_RESPONSIBLE_CONTACTS: 'Open Responsible Contacts',
  SEND_ISSUE_TO_SUPPORT: 'Send This Issue to Support',
  CONTACT_SUPPORT: 'Contact Support',
  CALL_SUPPORT: 'Call Support',
  TEXT_SUPPORT: 'Text Support'
})

export const SUPPORT_IMAGE_TYPES = Object.freeze(['image/jpeg', 'image/png', 'image/webp'])
export const SUPPORT_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp'
export const SUPPORT_IMAGE_MAX_SIZE = 10 * 1024 * 1024

export const RESPONSIBLE_CONTACT_REASONS = Object.freeze([
  SUPPORT_ACTION_REASONS.NEEDS_MANAGER,
  SUPPORT_ACTION_REASONS.NEEDS_SCHEDULER,
  SUPPORT_ACTION_REASONS.NEEDS_PAYROLL,
  SUPPORT_ACTION_REASONS.NEEDS_HR,
  SUPPORT_ACTION_REASONS.NEEDS_CREDENTIALING,
  SUPPORT_ACTION_REASONS.NEEDS_ADMINISTRATOR
])

export const getSupportActionKey = action => `${action?.type ?? ''}:${action?.reason ?? ''}`

export const isKnownSupportAction = action => {
  if (action?.type === SUPPORT_ACTION_TYPES.CONTACT_SUPPORT) {
    return [
      SUPPORT_ACTION_REASONS.UNRESOLVED_TECHNICAL_ISSUE,
      SUPPORT_ACTION_REASONS.USER_REQUESTED_HUMAN_HELP
    ].includes(action.reason)
  }

  if (action?.type === SUPPORT_ACTION_TYPES.OPEN_RESPONSIBLE_CONTACTS) {
    return RESPONSIBLE_CONTACT_REASONS.includes(action.reason)
  }

  if (action?.type === SUPPORT_ACTION_TYPES.START_NEW_TOPIC) {
    return [SUPPORT_ACTION_REASONS.TOPIC_CHANGED, SUPPORT_ACTION_REASONS.MESSAGE_LIMIT_REACHED].includes(action.reason)
  }

  return false
}
